import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/product/list',
    method:'get',
    params:params
  })
}

export function fetchNewProductList(params) {
  return request({
    url:'/product/fetchNewProductList',
    method:'get',
    params:params
  })
}

export function fetchHotProductList(params) {
  return request({
    url:'/product/fetchHotProductList',
    method:'get',
    params:params
  })
}


export function fetchCxjProductList(params) {
  return request({
    url:'/product/fetchXcjProductList',
    method:'get',
    params:params
  })
}


export function fetchFlashProductList(params) {
  return request({
    url:'/product/fetchFlashProductList',
    method:'get',
    params:params
  })
}

export function fetchSimpleList(params) {
  return request({
    url:'/product/simpleList',
    method:'get',
    params:params
  })
}

export function updateDeleteStatus(params) {
  return request({
    url:'/product/update/deleteStatus',
    method:'post',
    params:params
  })
}

export function updateNewStatus(params) {
  return request({
    url:'/product/update/newStatus',
    method:'post',
    params:params
  })
}

export function updateRecommendStatus(params) {
  return request({
    url:'/product/update/recommendStatus',
    method:'post',
    params:params
  })
}

export function updatePublishStatus(params) {
  return request({
    url:'/product/update/publishStatus',
    method:'post',
    params:params
  })
}

export function createProduct(data) {
  return request({
    url:'/product/create',
    method:'post',
    data:data
  })
}

export function updateProduct(id,data) {
  return request({
    url:'/product/update/'+id,
    method:'post',
    data:data
  })
}

export function getProduct(id) {
  return request({
    url:'/product/updateInfo/'+id,
    method:'get',
  })
}

export function getVcList() {
  return request({
    url:'/product/getVcList',
    method:'get',
  })
}

export function getCategoryMaintenance() {
  return request({
    url:'/productCategory/categoryMaintenance/lists',
    method:'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js